import React, { useEffect, useState, useContext } from "react";
import { useArtists, useTours, useEvents, useEventById } from "../contexts/ArtistContext";
import {
    Modal,
    Box,
    Typography,
    Button,
    TextField,
    Select,
    MenuItem,
    InputLabel,
    FormControl,
    Autocomplete,
    CircularProgress
} from "@mui/material";
import { GoogleMap, Marker } from "@react-google-maps/api";


import { getHeaders, dataConnect, functions } from "../firebaseConfig";
import { getAllEventTypes, getAllEventStatuses, venueSearch, createTourLocation, createVenue, getEventById, getArtistCrewMembers, getCrewMembersByEvent } from "@firebasegen/default-connector";
import { createEvent, updateEvent, createEventStatus, createEventType, addEventCrew, createTicketSource, updateTicketSourceUrl } from "@firebasegen/default-connector";
import { EventStatuses, EventTypes, EventTypeGroup } from "../constants/common";
import VenueSearchField from "../components/VenueSearchField";
import { GoogleMapsContext } from "../constants/GoogleMapsProvider";
import useRefreshData from "../hooks/useRefreshData";

import { Divider, ListItemIcon, ListSubheader, Menu, FormControlLabel, Switch } from "@mui/material";
import { httpsCallable } from "firebase/functions";
import AddIcon from "@mui/icons-material/Add";

const EventModal = ({ show, handleClose, selectedDate, addEventToCalendar, initialEvent, onOpenCreateTour, onSuccess }) => {
    const { refreshData } = useRefreshData();
    const [artists, setArtists] = useState([]);
    // Participants chosen while creating (added to the event's crew on save)
    const [participants, setParticipants] = useState([]);
    const [artistCrew, setArtistCrew] = useState([]);
    const [copyAnchor, setCopyAnchor] = useState(null);
    // Same choices as the crew list's "Add crew" dialog
    const [participantsRsvp, setParticipantsRsvp] = useState(false);
    const [notifyParticipants, setNotifyParticipants] = useState(true);
    const [artistId, setArtistId] = useState("");
    const [chosenDate, setChosenDate] = useState(selectedDate || "");
    const [name, setName] = useState("");
    const [venue, setVenue] = useState("");
    const [tour, setTour] = useState("");
    const [tourId, setTourId] = useState("");
    const [tours, setTours] = useState([]);
    const [status, setStatus] = useState("");
    const [type, setType] = useState("");
    const [eventStatuses, setEventStatuses] = useState([]);
    const [eventTypes, setEventTypes] = useState([]);
    const [isOtherType, setIsOtherType] = useState(false);
    const [isOtherStatus, setIsOtherStatus] = useState(false);
    const [newEventType, setNewEventType] = useState({ name: "", color: "", icon: "", artistId, system: false });
    const [newEventStatus, setNewEventStatus] = useState({ name: "", color: "", icon: "", artistId, system: false });
    const [isSaving, setIsSaving] = useState(false);

    // Hooks for data fetching
    const { data: artistsData } = useArtists({ enabled: show });
    useEffect(() => {
        if (artistsData && artistsData.length > 0) {
            setArtists(artistsData);
            if (!artistId) setArtistId(artistsData[0].id);
        }
    }, [artistsData]);

    const { data: toursData } = useTours(artistId, { enabled: show && !!artistId });

    useEffect(() => {
        if (!show || !artistId || initialEvent) return;
        setParticipants([]);
        setParticipantsRsvp(false);
        setNotifyParticipants(true);
        getArtistCrewMembers(dataConnect, { artistId })
            .then((res) => setArtistCrew(res.data?.crewMembers || []))
            .catch((err) => { console.error("Error loading crew:", err); setArtistCrew([]); });
    }, [show, artistId, initialEvent]);

    const crewName = (cm) => `${cm.user?.firstName || ""} ${cm.user?.lastName || ""}`.trim() || cm.user?.email || "Unknown";

    // "Copy from event": take that event's crew into the selection
    const copyParticipantsFrom = async (eventId) => {
        setCopyAnchor(null);
        try {
            const res = await getCrewMembersByEvent(dataConnect, { eventId });
            const fromEvent = res.data?.crewMembers || [];
            setParticipants((prev) => {
                const seen = new Set(prev.map((p) => p.user?.id));
                return [...prev, ...fromEvent.filter((cm) => cm.user?.id && !seen.has(cm.user.id))];
            });
        } catch (err) {
            console.error("Error copying crew from event:", err);
            alert("Could not fetch the crew of that event.");
        }
    };
    useEffect(() => {
        if (toursData) {
            setTours(toursData);
        }
    }, [toursData]);

    const { data: allEventsData } = useEvents({ enabled: show });

    const [showVenueList, setShowVenueList] = useState(false); // ✅ Control list visibility
    const [debouncedSearch, setDebouncedSearch] = useState(""); // ✅ Debounced value
    const [venueSelected, setVenueSelected] = useState(false);

    const [description, setDescription] = useState("");
    const [otherArtists, setOtherArtists] = useState("");
    const [promoter, setPromoter] = useState("");
    const [setUp, setSetUp] = useState("");
    const [ageLimit, setAgeLimit] = useState("");
    const [ticketReleaseDate, setTicketReleaseDate] = useState("");
    const [announcementDate, setAnnouncementDate] = useState("");
    const [capacity, setCapacity] = useState("");
    const [comment, setComment] = useState("");
    const [hideModal, setHideModal] = useState(false);
    const [timezone, setTimezone] = useState(Intl.DateTimeFormat().resolvedOptions().timeZone);
    const [hasWasher, setHasWasher] = useState(false);
    const [hasDryer, setHasDryer] = useState(false);
    const [merchNotes, setMerchNotes] = useState("");
    const [crescatLink, setCrescatLink] = useState("");
    // Ticket link = url of the event's first ticket source (shown on the public page and widget)
    const [ticketUrl, setTicketUrl] = useState("");
    const [ticketSource, setTicketSource] = useState(null);




    const { isLoaded } = useContext(GoogleMapsContext);




    useEffect(() => {
        if (selectedDate !== undefined && selectedDate !== null) {
            setChosenDate(selectedDate);
        }
    }, [selectedDate]);

    const { data: fullEventData } = useEventById(initialEvent?.id);

    useEffect(() => {
        const eventData = { ...fullEventData, ...initialEvent };
        if (eventData && Object.keys(eventData).length > 0) {
            console.log("Setting Event Data (Initial or Full):", eventData);
            setArtistId(eventData.artist?.id || eventData.artistId || "");
            setChosenDate(eventData.date ?? "");
            setName(eventData.name ?? "");
            setVenue(eventData.venue ?? "");
            setTour(eventData.tourId || eventData.tour?.id || "");
            setTourId(eventData.tourId || eventData.tour?.id || "");
            setStatus(eventData.status ?? "");
            setType(eventData.type ?? "");
            setDescription(eventData.description ?? "");
            setOtherArtists(eventData.otherArtists ?? "");
            setPromoter(eventData.promoterId ?? "");
            setSetUp(eventData.setUp ?? "");
            setAgeLimit(eventData.ageLimit?.toString() ?? "");
            setTicketReleaseDate(eventData.ticketReleaseDate ?? "");
            setAnnouncementDate(eventData.announcementDate ?? "");
            setCapacity(eventData.capacity?.toString() ?? "");
            setComment(eventData.comment ?? "");
            setTimezone(eventData.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone);
            setHasWasher(eventData.hasWasher ?? false);
            setHasDryer(eventData.hasDryer ?? false);
            setMerchNotes(eventData.merchNotes ?? "");
            setCrescatLink(eventData.crescatLink ?? "");
            // getEventById has the source ids; other lists may not
            const source = (fullEventData?.ticketSources_on_event || eventData.ticketSources_on_event || []).find((s) => s.url) || null;
            setTicketSource(source);
            setTicketUrl(source?.url ?? "");
        }
    }, [initialEvent, fullEventData]);

    useEffect(() => {


        const fetchEventTypes = async () => {
            if (!show) return;
            const { data } = await getAllEventTypes(dataConnect);
            setEventTypes(data.eventTypes);
            // Only set default type for NEW events (not editing)
            if (data.eventTypes.length > 0 && !initialEvent) setType(prev => prev || data.eventTypes[0].id);
        };

        const fetchEventStatuses = async () => {
            if (!show) return;
            const { data } = await getAllEventStatuses(dataConnect);
            setEventStatuses(data.eventStatuses);
        };


        if (show) {
            fetchEventTypes();
            fetchEventStatuses();
        }

    }, [show]);




    // Reset tour selection when artist changes
    useEffect(() => {
        if (artistId && !initialEvent) {
            setTourId("");
        }
    }, [artistId]);






    const saveTicketUrl = async (eventId) => {
        const url = ticketUrl.trim();
        if (url === (ticketSource?.url ?? "")) return;
        if (ticketSource?.id) await updateTicketSourceUrl(dataConnect, { ticketSourceId: ticketSource.id, url });
        else if (!ticketSource && url) await createTicketSource(dataConnect, { eventId, url, description: "Tickets" });
    };

    const handleSubmit = async () => {
        if (!artistId || !chosenDate) {
            alert("Event must have a date and artist!");
            return;
        }

        if (!initialEvent && allEventsData) {
            const overlappingEvent = allEventsData.find(
                (e) => e.artist?.id === artistId && e.date === chosenDate
            );
            
            if (overlappingEvent) {
                const artistName = artists.find((a) => a.id === artistId)?.name || "artisten";
                const eventName = overlappingEvent.name || "Uten navn";
                const confirmed = window.confirm(
                    `Det finnes allerede et event på samme dato for "${artistName}". Eventet heter: "${eventName}". Er du sikker på at du vil legge til ett til?`
                );
                if (!confirmed) {
                    return;
                }
            }
        }

        setIsSaving(true);
        try {

        let finalType = type;
        let finalStatus = status;
        const headers = await getHeaders();

        if (isOtherType) {
            newEventType.artistId = artistId;
            const { data } = await createEventType(newEventType, headers);
            finalType = data.eventType_insert.id;
        }

        if (isOtherStatus) {
            newEventStatus.artistId = artistId;
            const { data } = await createEventStatus(dataConnect, newEventStatus);
            finalStatus = data.eventStatus_insert.id;
        }



        const newEvent = {
            artistId: artistId,
            date: chosenDate,
            name: name,
            tourId: tourId || null,
            venueId: (typeof venue === 'object' ? venue?.id : venue) || null,
            status: finalStatus,
            type: finalType,
            comment,
            description,
            otherArtists,
            promoterId: promoter || null,
            setUp,
            ageLimit: ageLimit ? parseInt(ageLimit, 10) : null,
            // On update an empty field clears the date (the announcement date decides what is public)
            ...(ticketReleaseDate || initialEvent ? { ticketReleaseDate: ticketReleaseDate || null } : {}),
            ...(announcementDate || initialEvent ? { announcementDate: announcementDate || null } : {}),
            capacity: capacity ? parseInt(capacity, 10) : null,
            timeZone: timezone, // Note: the mutation uses $timeZone in create and $timezone in update. Wait.
            hasWasher,
            hasDryer,
            merchNotes,
            crescatLink: crescatLink || null
        };

        // Mutation param name for timezone is $timeZone in CreateEvent and $timezone in UpdateEvent
        if (initialEvent) {
            newEvent.timezone = timezone;
            delete newEvent.timeZone;
        } else {
            newEvent.timeZone = timezone;

        }

        // if update
        if (initialEvent) {
            //add existing id
            newEvent.id = initialEvent.id;
            const { data } = await updateEvent(dataConnect, newEvent);
            await saveTicketUrl(initialEvent.id);
            if (onSuccess) onSuccess({ ...initialEvent, ...newEvent });
        } else {
            const { data } = await createEvent(dataConnect, newEvent);
            const newEventId = data?.event_insert?.id;
            if (newEventId) await saveTicketUrl(newEventId);
            if (newEventId && participants.length > 0) {
                await Promise.all(participants.map((p) =>
                    addEventCrew(dataConnect, { eventId: newEventId, userId: p.user.id, artistId, responseStatus: participantsRsvp ? "PENDING" : "NONE" })
                ));
                if (participantsRsvp || notifyParticipants) {
                    // Push + email, like the crew list does; never blocks the save
                    void httpsCallable(functions, "notifyEventCrew")({
                        eventId: newEventId,
                        userIds: participants.map((p) => p.user.id),
                        kind: participantsRsvp ? "invite" : "added",
                    }).catch((err) => console.warn("Participant notification failed:", err));
                }
            }
            if (onSuccess) onSuccess(newEvent);
            else if (addEventToCalendar) addEventToCalendar(newEvent);
        }



        handleClose();
        // Delay refreshData to prevent reading stale data from eventually consistent read replica, 
        // which would overwrite our optimistic updates.
        setTimeout(() => refreshData(artistId), 2000);
        } catch (error) {
            console.error("Error saving event:", error);
            alert("Failed to save event");
        } finally {
            setIsSaving(false);
        }
    };
    /*
        const handleTypeChange = (e) => {
            const selectedValue = e.target.value;
            setIsOther(selectedValue === "other");
            setType(selectedValue === "other" ? "" : selectedValue);
        };Æ*/

    return (
        <Modal open={show} onClose={handleClose}>
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper',
                color: 'text.primary',
                boxShadow: 24,
                p: 0,
                width: '90%',
                maxWidth: 800,
                maxHeight: '90vh',
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 1,
                outline: 'none'
            }}>
                {/* Header */}
                <Box sx={{ p: 2, borderBottom: '1px solid', borderColor: 'divider', bgcolor: 'surface.level1', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6" fontWeight={600}>
                        {initialEvent ? "Edit Event" : "Create Event"}
                    </Typography>
                </Box>

                {/* Content */}
                <Box sx={{ p: 4, overflowY: 'auto', flex: 1, display: 'flex', flexDirection: 'column', gap: 2 }}>

                    {artists.length > 1 && (
                        <FormControl fullWidth>
                            <InputLabel>Artist</InputLabel>
                            <Select
                                value={artistId}
                                onChange={(e) => setArtistId(e.target.value)}
                                label="Artist"
                            >
                                {artists.map((artist) => (
                                    <MenuItem key={artist.id} value={artist.id}>
                                        {artist.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}

                    {artists.length === 0 && (
                        <Typography variant="body2" color="error" sx={{ mb: 2 }}>
                            No artists found. Please add an artist first.
                        </Typography>
                    )}

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <TextField
                            fullWidth
                            label="Event Name"
                            value={name ?? ""}
                            onChange={(e) => setName(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Event Date"
                            type="date"
                            value={chosenDate}
                            onChange={(e) => setChosenDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>

                        <VenueSearchField
                            venue={venue}
                            key={`venue_search_${artistId}`}
                            fieldKey={`venue_search_${artistId}`}
                            artistId={artistId}
                            onChange={(venueId, venueData) => {
                                setVenue(venueData || venueId);
                                if (venueData && venueData.capacity) {
                                    setCapacity(venueData.capacity);
                                }
                            }}
                            showCreateVenue={(create) => setHideModal(create)}
                        />

                    {venue && venue.location && (
                        <GoogleMap center={venue.location} zoom={15} mapContainerStyle={{ height: "200px", width: "100%", borderRadius: '4px', border: '1px solid', borderColor: 'divider' }}>
                            <Marker position={venue.location} />
                        </GoogleMap>
                    )}

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel>Tour</InputLabel>
                            <Select
                                value={tourId}
                                label="Tour"
                                onChange={(e) => {
                                    if (e.target.value === "CREATE_NEW_TOUR") {
                                        onOpenCreateTour?.();
                                        setTourId(""); // Don't select the "create" option
                                    } else {
                                        setTourId(e.target.value);
                                    }
                                }}
                            >
                                <MenuItem value="">
                                    <em>None</em>
                                </MenuItem>
                                {tours.map((t) => (
                                    <MenuItem key={t.id} value={t.id}>
                                        {t.name} ({t.events_on_tour?.length || 0} shows)
                                    </MenuItem>
                                ))}
                                {tours.length > 0 && <Divider />}
                                <MenuItem value="CREATE_NEW_TOUR" sx={{ fontWeight: 600, color: 'primary.main' }}>
                                    <ListItemIcon>
                                        <AddIcon fontSize="small" color="primary" />
                                    </ListItemIcon>
                                    Create Tour
                                </MenuItem>
                            </Select>
                        </FormControl>
                        <TextField
                            fullWidth
                            label="Capacity"
                            type="number"
                            value={capacity}
                            onChange={(e) => setCapacity(e.target.value)}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', gap: 2 }}>
                        {/* Status */}
                        <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            {isOtherStatus ? (
                                <TextField
                                    label="Enter new status"
                                    value={newEventStatus.name}
                                    onChange={(e) => setNewEventStatus({ ...newEventStatus, name: e.target.value })}
                                />
                            ) : (
                                <Select
                                    value={status}
                                    onChange={(e) => {
                                        if (e.target.value === "other") {
                                            setIsOtherStatus(true);
                                            setStatus("");
                                        } else {
                                            setStatus(e.target.value);
                                        }
                                    }}
                                    label="Status"
                                >
                                    <MenuItem value=""><em>Select a status...</em></MenuItem>
                                    {EventStatuses.map((eventStatus) => (
                                        <MenuItem key={eventStatus.value} value={eventStatus.value}>
                                            {eventStatus.name}
                                        </MenuItem>
                                    ))}
                                    {eventStatuses.map((eventStatus) => (
                                        <MenuItem key={eventStatus.id} value={eventStatus.id}>
                                            {eventStatus.name}
                                        </MenuItem>
                                    ))}
                                    <MenuItem value="other">Other...</MenuItem>
                                </Select>
                            )}
                        </FormControl>

                        {/* Type */}
                        <FormControl fullWidth>
                            <InputLabel>Type</InputLabel>
                            {isOtherType ? (
                                <TextField
                                    label="Enter new type"
                                    value={newEventType.name}
                                    onChange={(e) => setNewEventType({ ...newEventType, name: e.target.value })}
                                />
                            ) : (
                                <Select
                                    value={type}
                                    onChange={(e) => {
                                        if (e.target.value === "other") {
                                            setIsOtherType(true);
                                            setType("");
                                        } else {
                                            setType(e.target.value);
                                        }
                                    }}
                                    label="Type"
                                >
                                    <MenuItem value=""><em>Select a type...</em></MenuItem>
                                    {Object.entries(
                                        EventTypes.reduce((acc, type) => {
                                            const group = type.group || 'OTHER';
                                            if (!acc[group]) acc[group] = [];
                                            acc[group].push(type);
                                            return acc;
                                        }, {})
                                    ).map(([group, types]) => [
                                        <ListSubheader key={`header-${group}`} sx={{ fontWeight: 'bold', lineHeight: '36px', bgcolor: 'background.paper' }}>
                                            {EventTypeGroup[group]?.name || 'Other'}
                                        </ListSubheader>,
                                        ...types.map((eventType) => (
                                            <MenuItem key={eventType.value} value={eventType.value} sx={{ pl: 4 }}>
                                                {eventType.name}
                                            </MenuItem>
                                        ))
                                    ])}
                                    {eventTypes.map((eventType) => (
                                        <MenuItem key={eventType.id} value={eventType.id}>
                                            {eventType.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        </FormControl>
                    </Box>

                    <Box>
                        <Typography variant="subtitle2">Public info</Typography>
                        <Typography variant="caption" color="text.secondary">
                            Shown on the artist's public page and widget once the event is confirmed and the announcement date has passed.
                        </Typography>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <TextField
                            fullWidth
                            label="Announcement date"
                            type="date"
                            value={announcementDate ?? ""}
                            onChange={(e) => setAnnouncementDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            fullWidth
                            label="Ticket release"
                            type="date"
                            value={ticketReleaseDate ?? ""}
                            onChange={(e) => setTicketReleaseDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Box>
                    <TextField
                        fullWidth
                        label="Ticket link"
                        value={ticketUrl}
                        onChange={(e) => setTicketUrl(e.target.value)}
                        placeholder="https://..."
                    />
                    <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' } }}>
                        <TextField
                            fullWidth
                            label="Other artists"
                            value={otherArtists ?? ""}
                            onChange={(e) => setOtherArtists(e.target.value)}
                        />
                        <TextField
                            fullWidth
                            label="Age limit"
                            type="number"
                            value={ageLimit}
                            onChange={(e) => setAgeLimit(e.target.value)}
                        />
                    </Box>

                    <TextField
                        fullWidth
                        label="Link til event-plan (Crescat)"
                        value={crescatLink}
                        onChange={(e) => setCrescatLink(e.target.value)}
                        placeholder="https://app.crescat.io/..."
                    />

                    <TextField
                        fullWidth
                        label="Description"
                        value={description}
                        onChange={(e) => setDescription(e.target.value)}
                        multiline
                        rows={3}
                    />

                    <TextField
                        fullWidth
                        label="Comment"
                        multiline
                        rows={2}
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                    />

                    <TextField
                        fullWidth
                        label="Merchandise Notes"
                        multiline
                        rows={2}
                        value={merchNotes}
                        onChange={(e) => setMerchNotes(e.target.value)}
                    />

                    <Box sx={{ display: 'flex', gap: 4, mt: 1 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body2">Washer</Typography>
                            <input
                                type="checkbox"
                                checked={hasWasher}
                                onChange={(e) => setHasWasher(e.target.checked)}
                                style={{ width: 18, height: 18 }}
                            />
                        </Box>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography variant="body2">Dryer</Typography>
                            <input
                                type="checkbox"
                                checked={hasDryer}
                                onChange={(e) => setHasDryer(e.target.checked)}
                                style={{ width: 18, height: 18 }}
                            />
                        </Box>
                    </Box>

                    {!initialEvent && (
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'flex-start', flexWrap: 'wrap' }}>
                            <Autocomplete
                                multiple
                                options={artistCrew}
                                value={participants}
                                onChange={(e, value) => setParticipants(value)}
                                getOptionLabel={crewName}
                                isOptionEqualToValue={(a, b) => a.user?.id === b.user?.id}
                                renderInput={(params) => <TextField {...params} label="Participants" placeholder="Search crew…" />}
                                sx={{ flex: '1 1 240px', minWidth: 0 }}
                            />
                            <Button variant="outlined" onClick={(e) => setCopyAnchor(e.currentTarget)} sx={{ whiteSpace: 'nowrap', mt: 1, flexShrink: 0 }}>
                                Copy from event
                            </Button>
                            {participants.length > 0 && (
                                <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap', flexBasis: '100%' }}>
                                    <FormControlLabel
                                        control={<Switch size="small" checked={participantsRsvp} onChange={(e) => setParticipantsRsvp(e.target.checked)} />}
                                        label="Require RSVP"
                                    />
                                    <FormControlLabel
                                        control={<Switch size="small" checked={participantsRsvp || notifyParticipants} disabled={participantsRsvp} onChange={(e) => setNotifyParticipants(e.target.checked)} />}
                                        label="Notify them (push + email)"
                                    />
                                </Box>
                            )}
                            <Menu anchorEl={copyAnchor} open={Boolean(copyAnchor)} onClose={() => setCopyAnchor(null)}>
                                {(allEventsData || [])
                                    .filter((ev) => ev.artist?.id === artistId && ev.id !== initialEvent?.id)
                                    .sort((a, b) => (b.date || "").localeCompare(a.date || ""))
                                    .slice(0, 30)
                                    .map((ev) => (
                                        <MenuItem key={ev.id} onClick={() => copyParticipantsFrom(ev.id)}>
                                            {ev.date} – {ev.name || ev.venue?.name || "Event"}
                                        </MenuItem>
                                    ))}
                                {!(allEventsData || []).some((ev) => ev.artist?.id === artistId) && (
                                    <MenuItem disabled>No other events for this artist</MenuItem>
                                )}
                            </Menu>
                        </Box>
                    )}

                    <Autocomplete
                        options={typeof Intl.supportedValuesOf === "function"
                            ? Intl.supportedValuesOf("timeZone")
                            : ["UTC", "Europe/Oslo", "America/New_York"]
                        }
                        value={timezone}
                        onChange={(event, newValue) => {
                            setTimezone(newValue);
                        }}
                        renderInput={(params) => <TextField {...params} label="Time Zone" />}
                        fullWidth
                    />
                </Box>

                {/* Footer */}
                <Box sx={{ p: 2, borderTop: '1px solid', borderColor: 'divider', bgcolor: 'surface.level1', display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                    <Button variant="outlined" onClick={handleClose} disabled={isSaving} color="inherit">
                        Cancel
                    </Button>
                    <Button 
                        variant="contained" 
                        onClick={handleSubmit} 
                        disableElevation
                        disabled={isSaving}
                        startIcon={isSaving ? <CircularProgress size={20} color="inherit" /> : null}
                    >
                        {isSaving ? "Saving..." : (initialEvent ? "Update Event" : "Create Event")}
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default EventModal;